export default "__VITE_ASSET__9adbea10__"